import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { RMWContext } from 'app/shared/providers/RMWContext';

import analyticsUtils from 'app/client/utils/analyticsUtils';

import ModalConstants from 'app/shared/constants/ModalConstants';
import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';

import ModalActions from 'app/shared/actions/ModalActions';

import {
    PropertiesSelectors,
} from 'app/shared/selectors';

import {
    Flex,
    Image,
    Label,
    LabeledControl,
    Radio,
    Spacer,
    Text,
} from '@zillow/constellation';

import { Center } from '@zillow/zrs-comet';

import ModalFooter from 'app/shared/components/Modal/ModalFooter';
import Popularity from 'app/shared/images/Popularity.svg';

import {
    StyledMDActionsContainer,
    StyledMDContainer,
    StyledMDContent,
    StyledMDContentContainer,
} from 'app/shared/containers/ModalContainer/StyledComponents';

const CHOICES = {
    INCORRECT: {
        id: 'INCORRECT',
        text: 'My listing has incorrect or outdated information.',
        gaLabel: 'IncorrectInformation',
    },
    SOURCE: {
        id: 'SOURCE',
        text: 'I want to change my listing source.',
        gaLabel: 'ChangeListingSource',
    },
    SUPPORT: {
        id: 'SUPPORT',
        text: 'Neither of these. I need to contact support.',
        gaLabel: 'ContactSupport',
    },
};

const ListingIssuesModal = () => {
    const dispatch = useDispatch();
    const { paths } = React.useContext(RMWContext);
    const { listingAlias } = useSelector(state => PropertiesSelectors.makeCurrentProperty(state));
    const [choiceId, setChoiceId] = React.useState(null);

    const handleCloseModal = () => dispatch(ModalActions.hideModal());

    const handleSubmit = () => {
        const choice = CHOICES[choiceId];
        dispatch(analyticsUtils.track.GAEventV2(AnalyticsConstants.GA_EVENTS.VIEW_LISTING_ISSUES_MODAL, {
            label: choice.gaLabel,
        }));
        if (choiceId === 'INCORRECT') {
            dispatch(ModalActions.showModal({
                modalType: ModalConstants.FIX_INCORRECT_INFORMATION_MODAL,
                header: 'Fix incorrect or outdated information',
                isFluid: true,
            }));
        } else if (choiceId === 'SOURCE') {
            window.router.transitionTo(`${paths.propertiesPage}/${listingAlias}/${paths.propertyDetailsSources}`);
            handleCloseModal();
        } else {
            window.location.href = 'mailto:rentalshelp@zillowgroup.com';
            handleCloseModal();
        }
    };

    return (
        <StyledMDContainer>
            <StyledMDContentContainer>
                <StyledMDContent>
                    <Spacer marginBottom="xs">
                        <Flex display="flex" flexDirection="column" alignItems="center">
                            <Spacer marginY="xs">
                                <Image src={Popularity} alt="popularity image" />
                            </Spacer>
                            <Spacer paddingBottom="sm">
                                <Center>
                                    <Text fontType="h6">
                                        How can we help you?
                                    </Text>
                                </Center>
                            </Spacer>
                        </Flex>
                        <Spacer paddingBottom="sm">
                            {Object.keys(CHOICES).map((choiceKey) => {
                                const choice = CHOICES[choiceKey];
                                return (
                                    <LabeledControl
                                        key={choice.id}
                                        controlId={`LabeledControl-choice-${choice.id}`}
                                        label={<Label>{choice.text}</Label>}
                                        control={(
                                            <Radio
                                                name={`LabeledControl-choice-${choice.id}`}
                                                checked={choice.id === choiceId}
                                                onChange={() => setChoiceId(choice.id)}
                                            />
                                        )}
                                    />
                                );
                            })}
                        </Spacer>
                    </Spacer>
                </StyledMDContent>
            </StyledMDContentContainer>
            <StyledMDActionsContainer>
                <ModalFooter
                    cancelText="Cancel"
                    submitText="Next"
                    isSubmitDisabled={choiceId === null}
                    onSubmit={handleSubmit}
                    onCancel={handleCloseModal}
                />
            </StyledMDActionsContainer>
        </StyledMDContainer>
    );
};

export { ListingIssuesModal };
export default ListingIssuesModal;
